import fetchApi from '../util/fetchApi';
import checkErrors from './checkErrors';

/**
 * Normalises both response shapes into { items, count, unreadCount, from, to }:
 *   - Legacy (pre-pagination): plain array  → wraps it, unreadCount derived locally
 *   - Current: NotificationPageResultDTO    → passes through
 */
function normalisePage(data) {
  if (Array.isArray(data)) {
    const unreadCount = data.filter(n => !n.cleared).length;

    return { items: data, count: data.length, unreadCount, from: 0, to: Math.max(0, data.length - 1) };
  }

  return data;
}

const NotificationsApi = {
  async list({ offset, size, sortBy, unreadOnly, search } = {}) {
    const data = (await checkErrors(await fetchApi.api.get('notifications', {
      query: { offset, size, sortBy, unreadOnly: unreadOnly || undefined, search: search || undefined },
      useCache: false,
    }))).data;

    return normalisePage(data);
  },

  async markAsRead({ id }) {
    return (await checkErrors(await fetchApi.api.post(`notifications/mark-read/${id}`))).data;
  },

  async bulkMarkAsRead({ ids }) {
    return (await checkErrors(await fetchApi.api.post('notifications/bulk-mark-read', { data: { ids } }))).data;
  },

  async markAllAsRead() {
    return (await checkErrors(await fetchApi.api.post('notifications/mark-read/all'))).data;
  },
};

export default NotificationsApi;
